import { PayloadAction } from '@reduxjs/toolkit';

import { AppState, MultiTechAreaGroup } from 'editor/src/store/app/types';

const setMultiTechAreaGroupsReducer = (
  state: AppState,
  {
    payload,
  }: PayloadAction<{
    areaGroups: MultiTechAreaGroup[];
    // GAPI-30848 (Bug B): caller may pre-compute the initial per-area tech
    // (e.g. from the loaded design's spread names) so the strip reflects the
    // customer's saved per-area picks on reopen. When omitted, fall back to
    // the legacy "first option wins" default.
    selectedTechByArea?: Record<string, string>;
  }>,
) => {
  state.multiTechAreaGroups = payload.areaGroups;
  if (payload.selectedTechByArea) {
    state.selectedTechByArea = payload.selectedTechByArea;
    return;
  }
  const next: Record<string, string> = {};
  payload.areaGroups.forEach((g) => {
    next[g.canonicalName] = g.options[0]?.technology ?? '';
  });
  state.selectedTechByArea = next;
};

export default setMultiTechAreaGroupsReducer;
